import { styled } from '@uhg-abyss/web/tools/styled';

export const TerminationBannerWrapper = styled('div', {
  '.abyss-badge-root': {
    maxWidth: '300px',
  },

  '.abyss-badge-content': {
    '@media (max-width: 464px)': {
      fontSize: '$xs',
    },
  },
});
